import { render } from "./AttributePanel.vue?vue&type=template&id=b906bf00&scoped=true"
import script from "./AttributePanel.vue?vue&type=script&lang=js"
export * from "./AttributePanel.vue?vue&type=script&lang=js"

import "./AttributePanel.vue?vue&type=style&index=0&id=b906bf00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b906bf00"]])

export default __exports__